import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getAllNaray8Chapters, getMyNaray8Library, getNaray8ByCategory, getNaray8Chapter, getNaray8Owner, getNaray8Story, getNaray8Writer, getNaray8WriterFollowers, getNaray8WriterFollowing, getNarray8Comment } from "../../redux/naray8/naray8Action";


export function useNaray8UploadStory(storyId) {
    return useQuery({
        queryKey: ["upload", "naray8", storyId],
        queryFn: () => getNaray8Owner(storyId),
        enabled: !!storyId
    })
}


export function useNaray8Writer(writerId, isMine) {
    return useQuery({
        queryKey: ["naray8", "writer", writerId],
        queryFn: () => getNaray8Writer(writerId, isMine),
    });
}

export function useNaray8WriterFollowers(writerId) {
    return useInfiniteQuery({
        queryKey: ["naray8", "writer", "followers", writerId],
        queryFn: ({ pageParam = 1 }) => getNaray8WriterFollowers(writerId, { page: pageParam }),
        getNextPageParam: (lastPage) => {
            const { currentPage, totalPages } = lastPage.pagination
            return currentPage < totalPages ? currentPage + 1 : undefined
        },
        enabled: !!writerId
    })
}

export function useNaray8Library() {
    return useInfiniteQuery({
        queryKey: ["naray8", "library"],
        queryFn: ({ pageParam = 1 }) => getMyNaray8Library({ page: pageParam }),
        getNextPageParam: (lastPage) => {
            const { currentPage, totalPages } = lastPage.pagination
            return currentPage < totalPages ? currentPage + 1 : undefined
        }
    })
}


export function useNaray8WriterFollowing() {
    return useInfiniteQuery({
        queryKey: ["naray8", "writer", "following"],
        queryFn: ({ pageParam = 1 }) => getNaray8WriterFollowing({ page: pageParam }),
        getNextPageParam: (lastPage) => {
            const { currentPage, totalPages } = lastPage.pagination
            return currentPage < totalPages ? currentPage + 1 : undefined
        }
    })
}


export function useGetNaray8byId(narrateId) {
    return useQuery({
        queryKey: ["naray8", narrateId],
        queryFn: () => getNaray8Story(narrateId),
    });
}

export function useGetNaray8Comments({narrateId, chapterId}) {
    return useInfiniteQuery({
        queryKey: chapterId ? ["naray8", "chapter", chapterId, "comments"] : ["naray8", narrateId, "comments"],
        queryFn: ({ pageParam = 1 }) => getNarray8Comment({ narrateId, chapterId, page: pageParam }),
        getNextPageParam: (lastPage) => {
            const { currentPage, totalPages } = lastPage.pagination
            return currentPage < totalPages ? currentPage + 1 : undefined
        },
        enabled: !!narrateId || !!chapterId
    });
}

export function useAllNaray8Chapters(narrateId) {
    return useQuery({
        queryKey: ["naray8", narrateId, "chapters"],
        queryFn: () => getAllNaray8Chapters(narrateId),
    });
}

export function useNaray8ChapterById(chapterId) {
    return useQuery({
        queryKey: ["naray8", "chapter", chapterId],
        queryFn: () => getNaray8Chapter(chapterId),
    });
}

export function useInfiniteCategoryNaray8Stories({ slug, status, filter }) {
    return useInfiniteQuery({
        queryKey: ["naray8", "categories", slug, filter, ...(status ? [status] : [])],
        queryFn: ({ pageParam = 1 }) => getNaray8ByCategory({ slug, filter, status }, { page: pageParam }),
        getNextPageParam: (lastPage) => {
            const { currentPage, totalPages } = lastPage.pagination;
            if (currentPage < totalPages) {
                return currentPage + 1;
            }
            return undefined;
        },
        initialPageParam: 1,
    });
}
